import React, { Component } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import BsyTextEditor from "../../BsyTextEditor";
import { BsyUtils } from "../../../utils/Utils";
import tipAlert from "../../../Login/BsyAlertTip/Staticize";
import _ from "lodash";
import { createTooltip } from "../../../utils/createTooltip";
import {
  APP_GROUP_TITLE_MAX_LIMIT,
  BsyConfig,
} from "../../../global/BsyConfig";
import { ReactSortable } from "react-sortablejs";

export default class GroupConfig extends Component {
  constructor(props) {
    super(props);
    this.state = {
      apps: props.apps ? [...props.apps] : [],
    };
    this.refMap = {};
    this.elementRef = React.createRef();
  }

  gotoErrorGroup = (group) => {
    this.elementRef.current
      .querySelector(`.group-item.k${group._id}`)
      .scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
  };

  findDuplicates = (arr) => {
    // 使用 Map 来统计每个元素出现的次数
    const countMap = new Map();

    // 统计每个元素出现的次数
    arr.forEach((item) => {
      countMap.set(item.name, (countMap.get(item.name) || 0) + 1);
    });

    // 过滤出现次数大于1的元素
    const duplicates = [];
    countMap.forEach((count, item) => {
      if (count > 1) {
        duplicates.push(item);
      }
    });

    return arr.reduce((acc, item) => {
      if (duplicates.includes(item.name)) {
        acc[item._id] = item;
      }
      return acc;
    }, {});
  };

  checkGroup = () => {
    let isError = false;

    const duplicates = this.findDuplicates(this.state.apps);

    (this.state.apps || []).map((group, index) => {
      const component = this.refMap[group._id];

      if (duplicates[group._id]) {
        component.setTextState(BsyConfig().States.ERROR);
        if (!isError) {
          isError = true;
          this.gotoErrorGroup(group);
          tipAlert({
            type: "warning",
            msg: React.language("app.group.repeat"),
          });
        }
        return null;
      }

      if (component) {
        if (!component.customCheckValidate()) {
          if (!isError) {
            isError = true;
            this.gotoErrorGroup(group);
            tipAlert({
              type: "warning",
              msg: component.errorTipText,
            });
          }
        }
      }
      return null;
    });

    return isError;
  };

  componentDidMount = () => {
    const { show, hide } = createTooltip();
    this.showTooltip = show;
    this.hideTooltip = hide;
  };

  componentWillUnmount() {
    this.hideTooltip();
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    this.setState(
      {
        apps: nextProps.apps ? [...nextProps.apps] : [],
      },
      () => {
        if (this.newGroupId) {
          this.elementRef.current
            .querySelector(`.group-item.k${this.newGroupId}`)
            .scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          this.newGroupId = null;
        }
      }
    );
  }

  onDragEnd = (result) => {
    const { destination, source } = result;
    if (
      !destination ||
      (destination.droppableId === source.droppableId &&
        destination.index === source.index)
    ) {
      return;
    }

    const newApps = Array.from(this.state.apps);
    const [removed] = newApps.splice(source.index, 1);
    newApps.splice(destination.index, 0, removed);
    this.props.onSetGroup(newApps);
  };

  updateGroupName = (group, name) => {
    const apps = this.state.apps.map((item, i) => {
      if (group._id === item._id) {
        return { ...item, name: name };
      }
      return item;
    });
    this.props.onSetGroup(apps);
  };

  removeGroup = (group) => {
    if (!BsyUtils.isObjectEmpty(group.apps)) {
      tipAlert({
        msg: React.language("app.group.deleted"),
        type: "warning",
      });
      return;
    }
    delete this.refMap[group._id];
    this.props.onSetGroup(
      this.state.apps.filter((item, i) => {
        return item._id !== group._id;
      })
    );
  };

  getGroupName = () => {
    let i = 1;
    while (1) {
      if (i > 1000) {
        return React.language("group");
      }
      const newName = `${React.language("group")}${i}`;
      if (this.state.apps.find((item) => item.name === newName)) {
        i++;
      } else {
        return newName;
      }
    }
  };

  addGroup = () => {
    this.newGroupId = BsyUtils.Ids24();
    this.props.onSetGroup([
      ...this.state.apps,
      {
        _id: this.newGroupId,
        name: this.getGroupName(),
        apps: [],
      },
    ]);
  };

  checkGroupRepeat = (select) => {
    const apps = this.state.apps;
    const names = apps.map((item) => ({ name: item.name, id: item._id }));
    const repeat = names.filter(
      (item) => item.name === select.name && select.id !== item.id
    );
    return repeat;
  };

  onGroupChange = (apps) => {

    if (!_.isEqual(apps, this.state.apps)) {
      this.props.onSetGroup([...apps]);
    }
  };

  renderGroupList = () => {
    
    return (
      <div className="bsy-group-list" ref={this.elementRef}>
        <div className="list-header-wrapper">
          <div className="list-header">{React.language("app.group")}</div>

          <ReactSortable
            className="list-content"
            forceFallback={true}
            list={this.state.apps}
            setList={this.onGroupChange}
            handle={".drag-handle"}
          >
            {this.state.apps.map((group, index) => {
              const tmgroup = _.cloneDeep(group);
              return (
                <div
                  key={`${group._id}`}
                  className={`group-item k${group._id} `}
                  onClick={(event) => {
                    this.props.onJumpGroup(tmgroup._id);
                  }}
                >
                  <span className="name">
                    <BsyTextEditor
                      height={34}
                      getContext={(ref) => {
                        this.refMap[tmgroup._id] = ref;
                      }}
                      allowBlank={false}
                      onCustomCheckValidate={(val, te, ref) => {
                        if (val.length > APP_GROUP_TITLE_MAX_LIMIT) {
                          ref.setTextState(
                            BsyConfig().States.ERROR,
                            React.language("title.len", {
                              title: React.language("app.group"),
                              len: APP_GROUP_TITLE_MAX_LIMIT,
                            })
                          );

                          return false;
                        }
                        if (BsyUtils.isObjectEmpty(val)) {
                          ref.setTextState(
                            BsyConfig().States.ERROR,
                            React.language("app.group") +
                              React.language("error.3001")
                          );
                          return false;
                        }
                        ref.setTextState();
                        return true;
                      }}
                      onStopEdit={(t, d, ref) => {
                        if (!ref.customCheckValidate()) {
                          tipAlert({
                            type: "warning",
                            msg: ref.errorTipText,
                          });
                          // return;
                        }

                        const repeat = this.checkGroupRepeat({
                          id: tmgroup._id,
                          name: t,
                        });
                        if (repeat.length > 0) {
                          tipAlert({
                            type: "warning",
                            msg: React.language("app.group.repeat"),
                          });
                          this.refMap[tmgroup._id].setTextState(
                            BsyConfig().States.ERROR
                          );
                          repeat.map((item) => {
                            this.refMap[item.id].setTextState(
                              BsyConfig().States.ERROR
                            );
                            return null;
                          });
                          // return;
                        }
                        this.updateGroupName(tmgroup, t);
                      }}
                      value={group.name}
                    />
                  </span>
                  <i
                    className="icon-bsy-move1 drag-handle"
                    title={React.language("move.sort")}

                    // onMouseEnter={(e) => {
                    //   this.showTooltip(
                    //     e.currentTarget,
                    //     React.language("move.sort"),
                    //     "bottom",
                    //     10
                    //   );
                    // }}
                    // onMouseLeave={() => {
                    //   this.hideTooltip();
                    // }}
                  />
                  <i
                    className={`icon-remove ${
                      tmgroup._id === "default" ? "d" : ""
                    }`}
                    style={{
                      opacity: tmgroup._id === "default" ? 0.5 : 1,
                      cursor:
                        tmgroup._id === "default" ? "not-allowed" : "pointer",
                    }}
                    title={
                      tmgroup._id === "default"
                        ? React.language("api.error7005")
                        : ""
                    }
                    // onMouseEnter={(e) => {
                    //   if (tmgroup._id === "default") {
                    //     this.showTooltip(
                    //       e.currentTarget,
                    //       React.language("api.error7005"),
                    //       "left",
                    //       10
                    //     );
                    //   }
                    // }}
                    // onMouseLeave={() => {
                    //   this.hideTooltip();
                    // }}
                    onClick={() => {
                      // 默认分组不能删除
                      if (tmgroup._id !== "default") {
                        this.removeGroup(group);
                      }
                    }}
                  />
                </div>
              );
            })}
          </ReactSortable>
          {/* {provided.placeholder}
                </div> */}
        </div>

        <div className="list-footer">
          <button className="add-btn" onClick={this.addGroup}>
            <i className="icon-bsy-add"></i>
            <span>{React.language("contact.group.add")}</span>
          </button>
        </div>
      </div>
    );
  };

  render() {
    return <>{this.renderGroupList()}</>;
  }
}
